export const STICKY_BAR_HEIGHT = 60;
export const BODY_MODIFIER = "has-itinerary-schedule-active";
